import type { DataStructureCommon } from 'types';

export const getSelectedItems = (items: Array<any>): Array<any> => (items || []).filter(item => item.isSelected || item.selected);

export const getValues = (items: Array<any>): Array<string> => items.map(item => item.labelWhenSelected || item.label);

export const joinItems = (items: Array<string>): string => items.join(',');

export const getCommonValues = (currentFilter: any, currentFilterName: string): any => {
  const filteredItems = getSelectedItems(currentFilter);
  const values = filteredItems.map(item => item.identifier);

  return {
    [currentFilterName]: joinItems(values)
  };
};

export const getMappedLocation = (items: Array<DataStructureCommon>): string => {
  const selectedLocations = getSelectedItems(items);
  return joinItems(getValues(selectedLocations));
};
